/**
 * Per-account custom SuperAgent models.
 *
 * Users can bring their own model + API key. The config document is stored under
 * `accounts/{accountId}/superAgentCustomModels/{id}` and is readable by account
 * members; the API key is stored separately, encrypted, and is never returned to
 * clients (`hasKey` merely indicates a key is set). Custom models are referenced
 * in a `SuperAgentModelSelection` via the `custom:{id}` option id.
 */
/** Prefix used to reference a custom model from a SuperAgentModelSelection. */
const CUSTOM_MODEL_OPTION_PREFIX = 'custom:';
/** Build the selection option id for a custom model. */
const toCustomModelOptionId = (id) => `${CUSTOM_MODEL_OPTION_PREFIX}${id}`;
/** Extract the custom model id from an option id, or undefined if not custom. */
const parseCustomModelOptionId = (optionId) => optionId?.startsWith(CUSTOM_MODEL_OPTION_PREFIX)
    ? optionId.slice(CUSTOM_MODEL_OPTION_PREFIX.length)
    : undefined;

export { CUSTOM_MODEL_OPTION_PREFIX, parseCustomModelOptionId, toCustomModelOptionId };
//# sourceMappingURL=super-agent-custom-model.esm.js.map
